import { Form, LocationType } from 'app/hooks/useGlobalForm';
import { checkVacationHomeFieldsErrors } from './vacationHomeValidator';

type LocationSide =
  | Form['deliveryLocation']
  | Form['returnLocation']
  | undefined;

const isLocationComplete = (
  side: LocationSide,
  bannedList?: string[],
): boolean => {
  if (!side?.location || !side.time) return false;
  if (side.location === LocationType.Resort) {
    return !!side.resort?.ResortId;
  }
  if (side.location === LocationType.VacationHome) {
    return !checkVacationHomeFieldsErrors({
      isSubmit: true,
      vacationHomeForm: side.vacationHome,
      bannedList,
    });
  }
  return true;
};

export { isLocationComplete };
